import React from 'react';
import { Hero } from './components/Hero';
import { Problem } from './components/Problem';
import { Solution } from './components/Solution';
import { Offers } from './components/Offers';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
export function App() {
  return <main className="min-h-screen bg-brand-dark font-sans selection:bg-brand-gold selection:text-brand-black" data-id="element-0">
      <Hero data-id="element-1" />
      <Problem data-id="element-2" />
      <Solution data-id="element-3" />
      <Offers data-id="element-4" />
      <Faq data-id="element-5" />
      <FinalCta data-id="element-6" />
    </main>;
}